import { IsWeixinOrAlipay } from '@/common/tools';
export default {
  name: 'Home',

  data() {
    return {
      isShow: true,
      url: 'm.liuhejing.cc',
      isWx: false,
      downBg: "/static/v2/images/browser_v2.jpg"
    };
  },

  mounted() {
    const domain = window.location.host;

    if (IsWeixinOrAlipay() == 13) {
      this.isWx = true;
      this.isShowBar = false;
      this.url = window.location.href;
    }

    if (domain == 'www.xinianfahui.org' || domain == 'm.xinianfahui.org') {
      this.isShow = false;
    }
  },

  metaInfo: {
    title: '智者行一',
    meta: [{
      charset: 'utf-8'
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
    }]
  }
};